import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const OrderConfirmation = () => {
  const { orderId } = useParams();

  return (
    <div className="min-h-screen flex items-center justify-center py-16" data-testid="order-confirmation-page">
      <Card className="max-w-2xl w-full p-12 text-center">
        <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-primary" />
        </div>
        <h1 className="heading-font text-4xl font-bold mb-4" data-testid="confirmation-title">Order Confirmed!</h1>
        <p className="text-lg text-muted-foreground mb-8">
          Thank you for your order. We'll send you a confirmation email shortly with your order details and tracking information.
        </p>
        <div className="bg-secondary/50 rounded-lg p-6 mb-8">
          <p className="text-sm text-muted-foreground mb-2">Order Number</p>
          <p className="text-2xl font-bold mono-font" data-testid="order-number">{orderId}</p>
        </div>
        <div className="flex gap-4 justify-center">
          <Link to="/shop">
            <Button variant="outline" className="rounded-full" data-testid="continue-shopping-confirmation-btn">
              Continue Shopping
            </Button>
          </Link>
          <Link to="/">
            <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full" data-testid="back-home-btn">
              Back to Home
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default OrderConfirmation;